import { SxProps, styled } from "@mui/material/styles";
import { rowFlexStyle } from "../Common/styles/flex";

export const QBArea = styled("div")({
  height: "calc(100vh - 144px)",
  display: "flex",
  alignItems: "start",
  padding: "8px",
});

export const headerStyle: SxProps = {
  height: "72px",
  backgroundColor: "#ffffff",
  position: "sticky",
  top: 0,
  width: "100%",
  borderBottom: "1px solid",
  borderColor: "#E5E7EB",
  ...rowFlexStyle,
  alignItems: "center",
  p: "0px 16px",
};

export const QBMessageWrapper = styled("div")(() => ({
  height: "calc(100vh - 144px)",
  width: "100%",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
}));

export const EmptyMessageWrapper = styled("div")(() => ({
  height: "100%",
  width: "100%",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
}));

export const QuestionListStyle: SxProps = {
  flex: "1",
  height: "100%",
  px: 1,
  overflowY: "auto",
};

export const QuestionItemStyle: SxProps = {
  width: "100%",

  boxShadow: "0px 0px 12px 0px rgba(0, 0, 0, 0.08)",

  py: 2,
  px: 2,
  border: 1,

  borderColor: "#E7E7E7",
  borderRadius: "12px",
  backgroundColor: "#FFFFFF",

  // "&:not(:last-child)": {
  marginBottom: 2.5,
  // },
};

export const QuestionDescriptorStyle: SxProps = {
  background: "#ffffff",

  border: 1,
  borderColor: "#CFCFC9",
  borderRadius: 1,

  minWidth: "76px",
  height: "40px",

  mr: 2,
  px: 1.5,
};

export const requiredStyles: SxProps = {
  display: "flex",
  "&::after": {
    content: '"*"',
    color: "red",
    marginLeft: "3px",
  },
};

export const previewIndexStyle: SxProps = {
  height: "50px",
  width: "50px",
  bgcolor: "primary.main",
  color: "#FFF",
  alignItems: "center",
  justifyContent: "center",
  flexShrink: 0,

  borderRadius: 0.5,
};

export const groupSectionStyle: SxProps = {
  width: "100%",
  mb: 2.5,
  borderRadius: "12px",
  border: "1px solid",
  borderColor: "#D7E3F4",
  bgcolor: "#F5F8FD",
  overflow: "hidden",
  boxShadow: "0px 0px 12px 0px rgba(15, 23, 42, 0.04)",
  "& .wmde-markdown": {
    backgroundColor: "transparent",
  },
};

export const groupSectionBodyStyle: SxProps = {
  display: "flex",
  flexDirection: "column",
  gap: 1.5,
  px: 2,
  pb: 2,
  pt: 0.5,
};

export const groupMemberItemStyle: SxProps = {
  ...QuestionItemStyle,
  ml: 0,
  width: "100%",
  mb: 0,
  marginBottom: 0,
  boxShadow: "0px 1px 6px 0px rgba(15, 23, 42, 0.06)",
};

export const groupHeaderItemStyle: SxProps = {
  width: "100%",
  py: 2,
  px: 2,
  backgroundColor: "transparent",
  boxShadow: "none",
  border: 0,
  borderRadius: 0,
  mb: 0,
};

export const groupBadgeStyle: SxProps = {
  height: 22,
  fontSize: 12,
  fontWeight: 600,
  bgcolor: "secondary.main",
  color: "primary.main",
  "& .MuiChip-label": {
    px: 1,
  },
};
